module.exports = __webpack_public_path__ + "img/ds7.a2006532.png";